import GoogleAdsIcon from "@/components/ui/OpticksIcons/GoogleAdsIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import GoogleSlimIntegrationStep1 from "./components/steps/GoogleSlimIntegrationStep1";
import GoogleSlimIntegrationStep2 from "./components/steps/GoogleSlimIntegrationStep2";

const googleSlimConfig: ChannelIntegrationConfig = {
  channelName: "Google Ads",
  channelDisplayName: "Google",
  platformKey: "google",
  oauthPlatformKey: "google",
  icon: <GoogleAdsIcon size={32} />,
  supportsOAuth: false,
  overviewPath: routesMap.integration.google.slim.path,
  linkingPath: routesMap.integration.google.steps.path,
  pixelManagementPath: routesMap.integration.channelsCenter.path + "?channel=google",
  guideSteps: [
    {
      content: (stepLabel) => (
        <GoogleSlimIntegrationStep1 stepLabel={stepLabel} />
      ),
    },
    {
      content: (stepLabel) => (
        <GoogleSlimIntegrationStep2 stepLabel={stepLabel} />
      ),
    },
  ],
};

const GoogleSlimIntegration = () => {
  return <ChannelIntegrationGuide config={googleSlimConfig} />;
};

export default GoogleSlimIntegration;
